import React, { useEffect } from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import FormLabel from "./formLabel"
import * as API from "../../services/httpService"
import { address } from "../../common/errorMessage"

function CustomFormPostalCode(props) {
  const { textDesc, form, field, maxLength, toUpperCase, targetModel, asterisk, disabled } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  let addressResponse = {}
  const GetAddress = postalCode => {
    return API.apiPostRequest("/Online/Address", null, {
      params: {
        postalCode: postalCode,
      },
    })
  }
  
  let showAsterisk = false
  if(asterisk !== undefined){ showAsterisk = true }

  // useEffect(() => {
  // if (field.value) {
  //   GetAddress(field.value)
  //     .then(response => {
  //       addressResponse = response.data
  //       let address = `${addressResponse.block}, ${addressResponse.street}, ${addressResponse.building}`
  //       form.setFieldValue(targetModel, address)
  //     })
  //     .catch()
  // }
  // }, [field.value.length === 6])

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} asterisk={showAsterisk}/>
        <Col xs={12} md={6} className="marginTop10px">
          <Field
            name={field.name}
            className={
              "d-block inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            onChange={e => {
              let value = e.target.value || ""
              if (toUpperCase) {
                value = value.toUpperCase()
              }
              form.setFieldValue(field.name, value)
            }}
            onBlur={e => {
              form.handleBlur(e)
              if (e.target.value.trim().length === 6 && !isNaN(e.target.value)) {
                GetAddress(e.target.value)
                  .then(response => {
                    addressResponse = response.data
                    let address = `${addressResponse.block}, ${addressResponse.street}, ${addressResponse.building}`
                    form.setFieldValue(targetModel, address)
                  })
                  .catch()
              }
            }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={
              toUpperCase
                ? field.value.toUpperCase()
                : field.value
                ? field.value
                : ""
            }
            disabled={disabled}
          />
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomFormPostalCode
